import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { BaseText } from '@/components/base'
import RecoverPasswordAndUpdateEmailBottomSheet from '@/components/RecoverPasswordAndUpdateEmailBottomSheet'
import { useAuthScopedStore } from '@/store/scoped'

export const ForgotPasswordBtn: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const setRecoverPasswordForm = useAuthScopedStore(
    (state) => state.setRecoverPasswordForm,
  )
  const setIdentificationMethod = useAuthScopedStore(
    (state) => state.setIdentificationMethod,
  )
  const handleForgotPassword = () => {
    setIsOpen(true)
  }

  return (
    <>
      <BaseText
        className="text-blue-500 font-semibold text-center cursor-pointer hover:text-blue-600"
        onClick={handleForgotPassword}
      >
        {t('form:actions.forgotPassword')}
      </BaseText>
      <RecoverPasswordAndUpdateEmailBottomSheet
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        receiveCodeByPhoneNumber={() => {
          setRecoverPasswordForm({
            recoveryMethod: 'phone',
          })
          setIdentificationMethod('phone')
          navigate('/auth/forgot-password/recover-with-phone')
        }}
        receiveCodeByEmail={() => {
          setRecoverPasswordForm({
            recoveryMethod: 'email',
          })
          setIdentificationMethod('email')
          navigate('/auth/forgot-password/recover-with-email')
        }}
      />
    </>
  )
}
